import AppState from '@/types/AppState';
import Menu from '@/enums/Menu';

const state: AppState = {
    activePanel: Menu.LIST,
};

export default state;
